import { BaseBallDrawer } from './BaseBallDrawer';
import { webConfig } from '../../../core/applicationConfig';
import { ballHelper } from '../../../core/ball/ballHelper';
import {
  BONUS_GAME_BALLS,
  BONUS_GAME_BALLS_CRACKS,
} from '../../../stateManagment';
import { gameService } from '../../../services/apiServices/GameService';

export class BallWebDrawer extends BaseBallDrawer {
  constructor() {
    super();
    this.positions = {
      left: {
        start: { x: 405, y: 370 },
        curve: { x: 320, y: 580 },
        end: { x: webConfig.width / 2 - 200, y: 748 },
      },
      right: {
        start: { x: webConfig.width - 405, y: 370 },
        curve: { x: webConfig.width - 320, y: 580 },
        end: { x: webConfig.width / 2 + 200, y: 748 },
      },
      center: {
        x: webConfig.width / 2,
        y: 760,
      },
    };
    this._scales = [.70, .75, .80, .85, .90, .93, .98, .98];
    this._positions = [0, 15, 30, 45, 60, 75, 88, 99];
    this._lastScale = 1.05;
    this.__setCurve();
  }

  setBall(color, onComplete) {
    return super.setBall({ color, onComplete, scale: 1.05 });
  }

  crackBall(crackState, color = this._color) {
    this._ballState = crackState || ballHelper.getNextState(this._ballState);
    this.ball = ballHelper.getBall(color, this._ballState);
    this.ball.scale.set(1.05);
    this.ballContainer.removeChildren();
    this.ballContainer.addChild(this.ball);
    return Promise.resolve(true);
  }

  execute() {
    if (gameService.isBonus) {
      this.setBonusGameBalls(BONUS_GAME_BALLS.getValue(), BONUS_GAME_BALLS_CRACKS.getValue());
    } else {
      this.setBalls();
      this.setBall(this.randomColor);
    }
  }
}
